module.exports = __webpack_public_path__ + "img/375.81ba502f.jpg";